import { render } from "./PaymentEntryForm.vue?vue&type=template&id=5c5c706f&scoped=true"
import script from "./PaymentEntryForm.vue?vue&type=script&lang=js"
export * from "./PaymentEntryForm.vue?vue&type=script&lang=js"

import "./PaymentEntryForm.vue?vue&type=style&index=0&id=5c5c706f&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5c706f"]])

export default __exports__